export enum ProductPillar {
  VET = 'vet',
  SPTRETAIL = 'sptretail',
}
